import debounce from 'lodash/debounce';
import {
    ssDispatch,
} from '~SpectateStore';
import {
    setBuildInfoEnabled,
} from '~SpectateStore/slices/clientStateSlice';

const NEXT_CLICK_THRESHOLD = 500;

const clicksManager = {
    goal: 5,
    cnt: 0,
    dbncd: debounce(cb => cb(), NEXT_CLICK_THRESHOLD),
    reset() {
        this.cnt = 0;
    },
    increment() {
        this.cnt++;
        this.dbncd(() => this.reset()); // Reset counter debounced.

        return this;
    },
    onGoalReached(callback) {
        if (this.cnt >= this.goal) {
            callback();
        }
    },
};

const updateAvailability = (isEnabled) => ssDispatch(
    setBuildInfoEnabled(isEnabled)
);

const enableBuildInfo = () => updateAvailability(true);
export const disableBuildInfo = () => updateAvailability(false);

export const incrementBuildInfoClick = () => {
    clicksManager
        .increment()
        .onGoalReached(enableBuildInfo);
};
